/**
 * Bot lifecycle presentation helpers shared by the Review and All-Bots pages.
 * Mirrors the backend state machine (provider-api/lifecycle.ts) — presentation
 * only; every transition is re-validated server-side.
 */

export const LIFECYCLE: Record<string, string[]> = {
  Draft: ['Submitted'],
  Submitted: ['InReview', 'Draft'],
  InReview: ['ReadyForTesting', 'Draft'],
  // Provider approval is MANDATORY: first publish is always the provider's
  // validation sign-off, so no admin Published buttons here. The only admin
  // path into Published is restoring from Suspended (server enforces too).
  ReadyForTesting: ['Testing', 'Draft'],
  Testing: ['Draft'],
  Published: ['Suspended'],
  Suspended: ['Published', 'Draft'],
};

export const ALL_STATUSES = [
  'Draft', 'Submitted', 'InReview', 'ReadyForTesting', 'Testing', 'Published', 'Suspended',
];

/** CSS suffix for the status pill (BotReviewPage.css `.status-pill.<kind>`). */
export function statusKind(status: string): string {
  switch (status) {
    case 'Published': return 'published';
    case 'Suspended': return 'suspended';
    case 'Draft': return 'draft';
    case 'Submitted': return 'submitted';
    case 'InReview': return 'inreview';
    case 'ReadyForTesting':
    case 'Testing': return 'testing';
    default: return 'draft';
  }
}

/** Destructive transitions require a confirmation + optional note. */
export function isDestructive(from: string, to: string): boolean {
  return to === 'Draft' || to === 'Suspended';
}

/** i18n key for an action button moving a bot from → to. */
export function actionKey(from: string, to: string): string {
  if (to === 'Draft') return 'action.reject';
  if (to === 'Suspended') return 'action.suspend';
  if (from === 'Suspended' && to === 'Published') return 'action.republish';
  return 'action.advance';
}

/** Rejection reason codes (mirror of provider-api/lifecycle.ts). */
export const REJECTION_REASONS = ['content', 'legal', 'quality', 'impersonation', 'pricing', 'other'];
